import { getSelectOptions } from 'utils/getSelectOptions'
import { IUserMotorCarrier } from '../types'

/**
 * Used to generate an array of motorCarriers
 * @example [{ value: 123, label: Truck Carrier }, { value:456, Driver Carrier } ]
 */
export const getCarrierOptions = (userMotorCarriers: IUserMotorCarrier[] = []) => {
  return getSelectOptions({
    options: userMotorCarriers,
    mapOption: ({ motorCarrier }) => {
      const { dotNumber: value } = motorCarrier || {}
      const { legalName: label } = motorCarrier || {}
      return { value, label }
    },
  })
}
